import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgRestrictions(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4.5 0 16 24" {...props}>
      <path
        fill="currentColor"
        d="M12.5 4a8 8 0 110 16 8 8 0 010-16zm-6 8a6 6 0 009.302 5.01L7.49 8.698A5.967 5.967 0 006.5 12zm6-6c-1.371 0-2.635.46-3.645 1.234l8.411 8.411A6 6 0 0012.5 6z"
      />
    </svg>
  );
}

export default tombacIcon('Restrictions')(SvgRestrictions);
